import React, { useState } from 'react';

export default function CommentInput({ onAddComment }) {
    const [commentText, setCommentText] = useState('');
    
    const handleSubmit = (e) => {
        e.preventDefault();
        if (commentText.trim()) {
            onAddComment(commentText.trim());
            setCommentText('');
        }
    };
    
    return (
        <form onSubmit={handleSubmit} style={{
            display: 'flex',
            gap: '8px',
            marginTop: '12px',
            direction: 'rtl'
        }}>
            <input
                type="text"
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                placeholder="הוסף הערה..."
                style={{
                    flex: 1,
                    padding: '10px 12px',
                    border: '1px solid #CCC',
                    borderRadius: '6px',
                    fontSize: '14px',
                    outline: 'none',
                    direction: 'rtl'
                }}
                onFocus={(e) => e.target.style.borderColor = '#2196F3'}
                onBlur={(e) => e.target.style.borderColor = '#CCC'}
            />
            <button
                type="submit"
                disabled={!commentText.trim()}
                style={{
                    padding: '10px 20px',
                    backgroundColor: commentText.trim() ? '#2196F3' : '#CCC',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: commentText.trim() ? 'pointer' : 'not-allowed',
                    transition: 'background-color 0.2s'
                }}
            >
                שלח
            </button>
        </form>
    );
}